import { render, staticRenderFns } from "./CurrentlyReadingSection.vue?vue&type=template&id=5a8410a2&"
import script from "./CurrentlyReadingSection.vue?vue&type=script&lang=js&"
export * from "./CurrentlyReadingSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports